import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, CardBody, CardFooter, Table } from 'reactstrap';
import { H4, H6, Btn, Spinner } from '../../../AbstractElements';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setDetail, setFilters } from '../../../Features/Learning/TestimonyProgram/testimonyProgramSlice';
import { setField } from '../../../Features/Learning/TestimonyProgram/addTestimonyProgramSlice';
import {
  fetchTestimonyPrograms,
  handleDeleteTestimonyProgram,
  handleEditTestimonyProgram,
  handleGetDetailTestimonyProgram,
  handleBackPagination,
  handleNextPagination,
  handleClickPagination
} from './TestimonyProgramUtils';
import PaginationComponent from '../Common/Pagination';
import TestimonyProgramPost from './TestimonyProgramPost';

const TestimonyProgramBox = ({ modal, toggle }) => {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.testimonyProgram.filters)
  const cards = useSelector(state => state.testimonyProgram.data.data)
  const pagination = useSelector(state => state.testimonyProgram.data.pagination)
  const isLoading = useSelector(state => state.testimonyProgram.isLoading)
  const [refatch, setRefatch] = useState(false)

  useEffect(() => {
    fetchTestimonyPrograms(dispatch, filters, setRefatch)
    window.scrollTo(0, 0);
  }, [refatch])

  return (
    <Fragment>
      {isLoading ? (
        <Col lg="12">
          <div className="loader-box">
            <Spinner attrSpinner={{ className: 'loader-30' }} />
          </div>
          <H6 attrH6={{ className: 'sub-title mb-0 text-center' }}>{'Data Loading...'}</H6>
        </Col>
      ) : (
        cards && cards.length > 0 && (
          <Col sm="12 order-2">
            <Card>
              <CardBody>
                <Table className="table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col" className="bg-primary text-light" style={{ width: '50px' }}>{'#'}</th>
                      <th scope="col" className="bg-primary text-light">{'Nama Group Testimoni'}</th>
                      <th scope="col" className="bg-primary text-light text-center" width="150px">{'Aksi'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      cards && cards.map((item, index) =>
                        <tr key={`course-${index}`} className="table-light">
                          <th>{pagination?.from + index}</th>
                          <td>{item?.name}</td>
                          <td className='text-center'>
                            <div>
                              {/* <Link to={`${process.env.PUBLIC_URL}/testimony-program/form/${item.id}`} className="p-1" onClick={() => handleEditTestimonyProgram(dispatch, item, setField)}>
                              </Link> */}
                              <Btn
                                attrBtn={{
                                  color: 'link',
                                  outline: true,
                                  className: 'p-1',
                                  onClick: () => handleEditTestimonyProgram(dispatch, item, setField, toggle)
                                }}
                              >
                                <i className="fa fa-edit mx-auto text-secondary fa-lg"></i>
                              </Btn>
                              <Link to={`${process.env.PUBLIC_URL}/testimony-program/detail/${item.id}`} className="p-1" onClick={() => handleGetDetailTestimonyProgram(dispatch, item, setDetail)}>
                                <i className="fa fa-info-circle mx-auto fa-lg"></i>
                              </Link>
                              <Btn
                                attrBtn={{
                                  color: 'link',
                                  outline: true,
                                  className: 'p-1',
                                  onClick: () => handleDeleteTestimonyProgram(dispatch, item?.id, setRefatch)
                                }}
                              >
                                <i className="fa fa-trash-o mx-auto text-danger fa-lg"></i>
                              </Btn>
                            </div >
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                {pagination && (
                  <PaginationComponent
                    pagination={pagination}
                    handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefatch)}
                    handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefatch)}
                    handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefatch)}
                  />
                )}
              </CardFooter>
            </Card>
          </Col>
        )
      )}

      {!cards || cards.length === 0 && (
        <Col lg="12">
          <H4 attrH4={{ className: 'sub-title mb-5 text-center' }}>{!cards ? 'Sumber Data Tidak Tersedia' : 'Data Tidak Ditemukan'}</H4>
        </Col>
      )}

      <TestimonyProgramPost modal={modal} toggle={toggle} />

    </Fragment>
  );
};

export default TestimonyProgramBox;